<!--
 * @Author: wzh
 * @LastEditTime: 2023-01-05 15:57:14
 * @Description: 认证记录 密码维护
-->
<template>
	<div>
		<Head :title="$t('home.password_action.title')" :iconUrl="require('@/assets/images/certife/pass_mant.png')" />

		<div class="search">
			<div>
				<a-date-picker
					style="width: 300px"
					v-model="searchForm.executeTime"
					valueFormat="YYYY-MM-DD"
					:placeholder="$t('home.account_certify.date_search')"
					@change="getList(1)"
				/>
			</div>
			<div>
				<a-select
					v-model="searchForm.messageAction"
					style="width: 300px"
					:placeholder="$t('home.password_action.action_search')"
					allowClear
					@change="getList(1)"
				>
					<a-select-option v-for="item in actionArr" :value="item.key" :key="item.key">{{ item.value }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-select
					v-model="searchForm.messageResult"
					style="width: 300px"
					:placeholder="$t('home.password_action.result_search')"
					allowClear
					@change="getList(1)"
				>
					<a-select-option value="success">{{ $t("home.account_certify.result_success") }}</a-select-option>
					<a-select-option value="fail">{{ $t("home.account_certify.result_failure") }}</a-select-option>
				</a-select>
			</div>
			<div>
				<a-button type="primary" icon="reload" @click="handleReset">{{ $t("base.btn.reset") }}</a-button>
			</div>
		</div>

		<List
			:pagination="pagination"
			addTitle=""
			ref="table"
			:loading="loading"
			:columns="columns"
			:isChecked="false"
			:dataSource="dataSource"
			@handleTableChange="handleTableChange"
		>
			<!-- 认证结果 -->
			<template v-slot:messageResult="{ text }">
				<span v-if="text == 'success'" style="color: #6BD31C"><a-icon type="check" /> {{ $t("home.account_certify.result_success") }}</span>
				<span v-else style="color: #FF0000"><a-icon type="exclamation-circle" /> {{ $t("home.account_certify.result_failure") }}</span>
			</template>
		</List>
	</div>
</template>

<script>
import Head from "../../compontents/Head";
import List from "@/components/public/list/ant";
import { deepClone } from "@/utils/deepclone";
import pagination from "@/utils/pagination";
import { commonAPI } from "@/apis";

export default {
	name: "passmant",
	components: { Head, List },
	data() {
		return {
			actionArr: [
				{ key: "create", value: this.$t("home.password_action.action_one") },
				{ key: "update", value: this.$t("home.password_action.action_two") },
				{ key: "delete", value: this.$t("home.password_action.action_three") },
			],
			searchForm: { executeTime: "", messageAction: undefined, messageResult: undefined },
			pagination: deepClone(pagination),
			columns: [
				{ title: this.$t("home.password_action.columns.execute_time"), dataIndex: "executeTime", align: "center" },
				{
					title: this.$t("home.password_action.columns.action_type"),
					dataIndex: "messageAction",
					align: "center",
					customRender: (text) => {
						let item = this.actionArr.find((o) => o.key == text);
						return item ? item.value : text;
					},
				},
				{ title: this.$t("base.table.ip"), dataIndex: "ip", align: "center" },
				{ title: this.$t("base.table.ip_location"), dataIndex: "ipLocation", align: "center" },
				{
					title: this.$t("home.password_action.columns.result"),
					dataIndex: "messageResult",
					align: "center",
					scopedSlots: { customRender: "messageResult" },
				},
			],
			dataSource: [],
			loading: false,
		};
	},
	created() {
		this.getList();
	},
	methods: {
		// 获取列表
		async getList(current) {
			if (current == 1) {
				this.pagination.current = 1;
			}
			let params = {
				pageNumber: this.pagination.current,
				pageSize: this.pagination.pageSize,
				topic: "password",
				...this.searchForm,
			};
			this.loading = true;
			const { code, data } = await commonAPI.getAction("/historys/systemLogs/fetch", params);
			if (code == 0) {
				this.dataSource = data.rows || [];
				this.pagination.total = data.records;
			}
			this.loading = false;
		},
		//   分页方法
		handleTableChange(pagination) {
			this.pagination = pagination;
			this.getList();
		},
		// 重置
		handleReset() {
			this.searchForm = { loginTime: "", loginType: undefined, message: undefined };
			this.getList(1);
		},
	},
};
</script>

<style lang="less" scoped>
.search {
	display: flex;
	margin-top: 20px;
	align-items: center;
	& > div {
		margin-right: 10px;
	}
}
</style>
